export const About = (props) => {
  return (
    <div id="about">
      <title>We deals with top ro company</title>
      <meta name="description" content="We deals with kent,ao smith,hul pureit, livepure,aquaguard ro water purifier."></meta>
      <div className="container" style={{ textAlign: 'justify' }}>
        <div className="row">
          <div className="col-xs-12 col-md-6">
            {" "}
            <img src="img/ro-water-about.png" className="img-responsive" alt="ro-repair-service-about-us" />{" "}
          </div>
          <div className="col-xs-12 col-md-6">
            <div className="about-text">
              <h2>About Us</h2>

              <p>Welcome to <b><strong>Water Purifier Services</strong></b> – your trusted partner for clean, safe, and healthy drinking water serving in . With extensive experience in the water purification industry, we are dedicated to providing reliable solutions for residential and commercial water purification needs.</p>
              <p>At <b><strong>Water Purifier Services</strong></b>, we are dedicated to providing top-notch water purifier services across India. Our expert team ensures that your water purifier runs at optimal performance, offering installation, maintenance, repair, and servicing for a wide range of water purification systems.</p>
              {/*
                <p>{props.data ? props.data.paragraph : "loading..."}</p>
              */}

            </div>

          </div>
        </div>
        <div className="abouttext">
          <h3><b><u>Who We Are</u></b></h3>
          <p>Ro water purifier services is your trusted partner for all  RO Water Purifier needs. We offer top-notch services, including installation, repair, and annual maintenance (AMC), ensuring your systems stay in peak condition. Our skilled technicians provide fast, reliable solutions to keep your home comfortable and water pure. Whether it’s a minor fix or routine servicing, we’re here to deliver professional, hassle-free service with a focus on customer satisfaction. Count on us for excellence every time!</p>

          <h3><b><u>Our Mission</u></b></h3>
          <p>Our mission is to deliver clean and safe drinking water to every home and business. We leverage advanced technologies and eco-friendly practices to provide cost-effective and sustainable solutions that meet our customers' expectations.</p>

          <h3><b><u>Why Choose Us ?</u></b></h3>
          <p><li><b>Expert Technicians:</b> Certified professionals with hands-on experience.</li></p>

          <p><li><b>Affordable Solutions:</b> Quality services at competitive prices.</li></p>

          <p><li><b>Customer-Focused:</b> Prompt and reliable support for all your needs.</li></p>

          <p><li><b>Eco-Friendly Practices:</b> Promoting sustainability and minimal environmental impact.</li></p>
        </div>
      </div>
    </div>
  );
};
